export enum IENVIRONMENT {
    'QA' = 'QA',
    'PRODUCTION' = 'PRODUCTION',
    'LOCAL' = 'LOCAL',
    'FEATURE' = 'FEATURE'   
}

class EnvService {
    public ENVIRONMENT: IENVIRONMENT | undefined = undefined
    public FEATURENAME: string | undefined = undefined
}

const env = new EnvService()

export  { env };